import { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'mobx';
import { ColumnAlign, ColumnLock } from './enum';
import { ShowHelp } from '../field/enum';
export const defaultMinWidth = 100;
/* eslint-disable react/prefer-stateless-function,react/no-unused-prop-types */
export default class Column extends Component {
}
Column.propTypes = {
    /**
     * 列对照的字段名
     */
    name: PropTypes.string,
    /**
     * 列宽
     * 不推荐给所有列设置宽度，而是给某一列不设置宽度达到自动宽度的效果
     */
    width: PropTypes.number,
    /**
     * 最小列宽
     */
    minWidth: PropTypes.number,
    /**
     * 列头
     */
    header: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func]),
    /**
     * 列脚
     */
    footer: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func]),
    /**
     * 单元格渲染回调
     */
    renderer: PropTypes.func,
    /**
     * 编辑器
     */
    editor: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.bool]),
    /**
     * 是否锁定
     * 可选值： false | true | 'left' | 'right'
     * @default false
     */
    lock: PropTypes.oneOf([ColumnLock.left, ColumnLock.right, true, false]),
    /**
     * 文字对齐方式
     * 可选值： 'left' | 'center' | 'right'
     */
    align: PropTypes.oneOf([ColumnAlign.left, ColumnAlign.center, ColumnAlign.right]),
    /**
     * 是否可调整宽度
     * @default true
     */
    resizable: PropTypes.bool,
    /**
     * 是否可排序
     * @default false
     */
    sortable: PropTypes.bool,
    /**
     * 是否可隐藏，设为false时不会出现在列过滤选项中
     * @default true
     */
    hideable: PropTypes.bool,
    /**
     * 是否可排序
     * @default false
     */
    /**
     * 列头提示信息
     */
    help: PropTypes.string,
    /**
     * 显示提示信息的方式
     *
     */
    showHelp: PropTypes.oneOf([ShowHelp.tooltip, ShowHelp.newLine, ShowHelp.none]),
    hidden: PropTypes.bool,
    colSpan: PropTypes.number,
    rowSpan: PropTypes.number,
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};
Column.__PRO_TABLE_COLUMN = true;
Column.defaultProps = {
    hidden: false,
    lock: false,
    resizable: true,
    sortable: false,
    hideable: true,
    minWidth: defaultMinWidth,
    showHelp: ShowHelp.tooltip,
};
export function minColumnWidth(col) {
    const hidden = get(col, 'hidden');
    if (hidden) {
        return 0;
    }
    const width = get(col, 'width');
    const min = get(col, 'minWidth');
    const minWidth = min === undefined ? defaultMinWidth : min;
    if (width === undefined) {
        return minWidth;
    }
    return Math.min(width, minWidth);
}
export function columnWidth(col) {
    const hidden = get(col, 'hidden');
    if (hidden) {
        return 0;
    }
    const width = get(col, 'width');
    if (width === undefined) {
        const minWidth = get(col, 'minWidth');
        if (minWidth === undefined) {
            return defaultMinWidth;
        }
        return minWidth;
    }
    return width;
}
